import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';

// No registramos service worker de app: /sw.js no existía (daba 404) y el viejo
// /service-worker.js (Workbox) quedó como huérfano cacheando la app vieja. La limpieza
// de esos huérfanos la hace el kill-switch en public/service-worker.js. El SW de push
// (firebase-messaging-sw.js) lo registra Firebase por su cuenta al pedir el token.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
